import script from './RunningLateReasonModal.vue2.js';
import normalizeComponent from '../../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Alert",
    {
      staticClass: "RunningLateReasonModal",
      attrs: {
        title: "Select a reason",
        isOpened: _vm.isOpened,
        hideConfirmButton: "",
        hideCancelButton: ""
      },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    _vm._l(_vm.delayReasons, function(delayReason, key) {
      return _c(
        "ButtonComponent",
        {
          key: delayReason,
          staticClass: "mt-3",
          attrs: {
            fullWidth: "",
            buttonStyle: "outline-white",
            buttonSize: "lg"
          },
          on: {
            click: function($event) {
              return _vm.captureDelayReason(key)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(delayReason) + "\n  ")]
      )
    }),
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
